module.exports = __webpack_public_path__ + "static/media/image3.6124b17f.jpg";